@if (product | productTitle: { fields: titleFields }; as productTitle) {
<div
  class="pcard-title text-truncate w-100 pcard-header-title"
  [title]="productTitle"
  data-e2e="pcard-title"
>
  {{ productTitle }}
</div>
}
